import { useQuery } from '@tanstack/react-query';

import { getActiveDeliverySettings } from 'apis/delivery-settings-api/api';

import { InsightEntity } from '../types';

const useDeliveryTypeChecks = (insightEntity: InsightEntity) => {
  const { data: venueActiveDeliverySettings } = useQuery(
    [`delivery-settings/${insightEntity.id}`],
    () => getActiveDeliverySettings(insightEntity.id),
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: insightEntity.type === 'venue',
    },
  );
  const isHybridDeliveryVenue = !!venueActiveDeliverySettings?.isFlexibleFulfillmentEnabled;
  const isSelfDeliveryOnlyVenue =
    !isHybridDeliveryVenue && venueActiveDeliverySettings?.activeDeliverySettingsType === 'self_delivery';

  return { isHybridDeliveryVenue, isSelfDeliveryOnlyVenue };
};

export default useDeliveryTypeChecks;
